<template lang="">
    <div class="accordion default-section-accordion" id="accordionExample">
        <!--  -->
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        Professional Summary
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <ProfessionalSummary/>
      </div>
    </div>
  </div>
  <!--  -->
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        Skills
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <Skills/>
      </div>
    </div>
  </div>
<!--  -->
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
       Work Experience
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <WorkExperience/>
      </div>
    </div>
  </div>
<!--  -->
   <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
       Education
      </button>
    </h2>
    <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <Education/>
      </div>
    </div>
  </div>
  <!--  -->
   <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
       Achievements & Certifications
      </button>
    </h2>
    <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <Certificates/>
      </div>
    </div>
  </div>
  <!--  -->
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
       References
      </button>
    </h2>
    <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        <References/>
      </div>
    </div>
  </div>
  <!--  -->
</div>

    <!-- <div class="default-section">
        <div class="heading-section fw-bold">
            CV Editor
        </div>
    </div>
    <div class="default-section thin-line">
        <ProfessionalSummary/>
    </div>
     <div class="default-section thin-line">
        <Skills/>
    </div>
    
     <div class="default-section thin-line">
        <WorkExperience/>
    </div>
    
     <div class="default-section thin-line">
        <Education/>
    </div>
     <div class="default-section thin-line">
        <Certificates/>
    </div> -->
     <div class="default-section thin-line mb-10">
        <!-- <References/> -->
        <button class="btn btn-default btn-preview" @click="ShowModal">Preview CV</button>
    </div>
   
    <!-- CV Viewer Modal -->
    <div class="modal fade" ref="cvReviewModal" id="cvViewerModal" tabindex="-1" aria-labelledby="cvViewerModalLabel" aria-hidden="true">
    <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="exampleModalLabel">Preview</div>
        <button class="btn btn-default close-btn" @click="CloseModal">
          <CloseIcon/>
        </button>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="modal-body">
        <!-- CV CONTENT -->
        <CVViewer/>
      </div>
      <div class="modal-footer">
        
      </div>
    </div>
  </div>
</div>
    <!--  -->
</template>
<script>
    import CVViewer from './CVViewer.vue';
    import ProfessionalSummary from './CVBuilderForms/ProfessionalSummary.vue';
    import WorkExperience from './CVBuilderForms/WorkExperience.vue';
    import Skills from './CVBuilderForms/Skills.vue';
    import Education from './CVBuilderForms/Education.vue';
    import Certificates from './CVBuilderForms/Certificates.vue';
    import References from './CVBuilderForms/References.vue';
    import CloseIcon from '@/components/IconComponents/CloseIcon.vue';
    import { Modal } from 'bootstrap';
export default {
     props:{
        cv:{
            type: Object,
            default: () => null
        }
    },
    components:{
        ProfessionalSummary, WorkExperience, Skills, Education, Certificates, CVViewer,
        References, CloseIcon
    },
    mounted(){
      this.modalInstance = new Modal(this.$refs.cvReviewModal);
    },
    methods:{
      ShowModal(){
        this.modalInstance?.show();
      },
     CloseModal(){
        this.modalInstance?.hide();
      }
    }
}
</script>
<style scoped>
    .heading-section{
       color:var(--navlink-active);
    }

    

    .thin-line{
        border-bottom:1px solid var(--lightgrey);
        padding-bottom:1.3rem;
    }

    .btn-preview{
        margin-top: 1rem;
        background:var(--nav);
        color:var(--page-header);
        width:100%;
        font-weight:bold;
        display: none;
    }

    .modal-body{
        padding:0px;
    }

    .modal-content{
        padding: 0px !important;
    }

    .accordion{
      transform: translateY(-0.8rem);
    }

    .accordion-button{
      background:var(--builder-accordion-button)!important;
      border-bottom:0px!important;
      color:var(--navlink-active);
         text-transform:uppercase;
        letter-spacing:0.2rem;
        font-size:0.7rem;
        font-weight:bold;
        color:var(--filters-accordion-text);
    }

    .accordion-item{
      border:1px solid var(--darkgrey2);
      background-color: var(--background);
    }

    .accordion-body{
      background: var(--background);
    }

    .accordion-button:not(.collapsed) {
    color: var(--page-header) !important;
  }

  .default-section.thin-line.mb-10{
    border:0px;
  }

    

    @media(max-width:768px){
        .btn-preview{
            display: block;
        }
    }
</style>